<template>
  <div v-if="cmsStatus.unavailable" class="cms-status-banner" role="alert">
    {{ message }}
    <template v-if="cmsStatus.stillUnavailable && !cmsStatus.checking">Still unavailable.</template>
    <button type="button" class="cms-status-banner-retry" :disabled="cmsStatus.checking" @click="tryAgain">
      {{ cmsStatus.checking ? 'Checking...' : 'Try again' }}
    </button>
  </div>
</template>

<script>
import {CMS_UNAVAILABLE_MESSAGE, CmsStatus, CmsStatusService} from "@/services/CmsStatusService";

// Shown while CMS can't be reached (see CmsStatusService), instead of an error popup per request.
export default {
  name: 'CmsStatusBanner',
  data() {
    return {
      cmsStatus: CmsStatus,
      message: CMS_UNAVAILABLE_MESSAGE,
    }
  },
  watch: {
    $route(to) {
      CmsStatusService.pageChanged(to)
    },
  },
  methods: {
    // Reloads the page once CMS answers, so it fetches its crew data again.
    async tryAgain() {
      if (await CmsStatusService.check()) {
        window.location.reload()
      }
    },
  },
}
</script>

<style scoped>
.cms-status-banner {
  margin: 12px 16px 8px;
  padding: 12px 16px;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background-color: #fef2f2;
  color: #b91c1c;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.cms-status-banner-retry {
  margin-left: 8px;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

.cms-status-banner-retry:hover,
.cms-status-banner-retry:disabled {
  text-decoration: none;
}

.cms-status-banner-retry:disabled {
  cursor: default;
}
</style>
